/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DamageAssessor } from '../models';
// @ts-ignore
import { Person } from '../models';
/**
 * DamageassessorsApi - axios parameter creator
 * @export
 */
export const DamageassessorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all damage assessors
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {boolean} [withAdmin] Set true if query with admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsGet: async (offset?: number, size?: number, withAdmin?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damageassessors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (withAdmin !== undefined) {
                localVarQueryParameter['withAdmin'] = withAdmin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific damage assessor
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorsIdGet', 'id', id)
            const localVarPath = `/damageassessors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the damage assessor
         * @param {number} id 
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsIdPut: async (id: number, person?: Person, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorsIdPut', 'id', id)
            const localVarPath = `/damageassessors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new damage assessor
         * @param {Person} person 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsPost: async (person: Person, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'person' is not null or undefined
            assertParamExists('damageassessorsPost', 'person', person)
            const localVarPath = `/damageassessors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageassessorsApi - functional programming interface
 * @export
 */
export const DamageassessorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageassessorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all damage assessors
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {boolean} [withAdmin] Set true if query with admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorsGet(offset?: number, size?: number, withAdmin?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageAssessor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorsGet(offset, size, withAdmin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific damage assessor
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the damage assessor
         * @param {number} id 
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorsIdPut(id: number, person?: Person, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorsIdPut(id, person, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new damage assessor
         * @param {Person} person 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorsPost(person: Person, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorsPost(person, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DamageassessorsApi - factory interface
 * @export
 */
export const DamageassessorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageassessorsApiFp(configuration)
    return {
        /**
         * Get all damage assessors
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {boolean} [withAdmin] Set true if query with admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsGet(offset?: number, size?: number, withAdmin?: boolean, options?: any): AxiosPromise<DamageAssessor> {
            return localVarFp.damageassessorsGet(offset, size, withAdmin, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific damage assessor
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsIdGet(id: number, options?: any): AxiosPromise<Person> {
            return localVarFp.damageassessorsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the damage assessor
         * @param {number} id 
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsIdPut(id: number, person?: Person, options?: any): AxiosPromise<Person> {
            return localVarFp.damageassessorsIdPut(id, person, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new damage assessor
         * @param {Person} person 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorsPost(person: Person, options?: any): AxiosPromise<void> {
            return localVarFp.damageassessorsPost(person, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DamageassessorsApi - object-oriented interface
 * @export
 * @class DamageassessorsApi
 * @extends {BaseAPI}
 */
export class DamageassessorsApi extends BaseAPI {
    /**
     * Get all damage assessors
     * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {boolean} [withAdmin] Set true if query with admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorsApi
     */
    public damageassessorsGet(offset?: number, size?: number, withAdmin?: boolean, options?: AxiosRequestConfig) {
        return DamageassessorsApiFp(this.configuration).damageassessorsGet(offset, size, withAdmin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific damage assessor
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorsApi
     */
    public damageassessorsIdGet(id: number, options?: AxiosRequestConfig) {
        return DamageassessorsApiFp(this.configuration).damageassessorsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the damage assessor
     * @param {number} id 
     * @param {Person} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorsApi
     */
    public damageassessorsIdPut(id: number, person?: Person, options?: AxiosRequestConfig) {
        return DamageassessorsApiFp(this.configuration).damageassessorsIdPut(id, person, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new damage assessor
     * @param {Person} person 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorsApi
     */
    public damageassessorsPost(person: Person, options?: AxiosRequestConfig) {
        return DamageassessorsApiFp(this.configuration).damageassessorsPost(person, options).then((request) => request(this.axios, this.basePath));
    }
}
